import React from 'react'
import { tokens } from '../../styles/desertFloraTheme'

const styles = {
  container: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6
  },
  label: {
    fontSize: 13,
    fontWeight: 600,
    color: tokens.ink,
    minWidth: 140
  },
  inputWrapper: {
    position: 'relative',
    display: 'inline-flex',
    alignItems: 'center'
  },
  input: {
    fontFamily: tokens.fontMono,
    fontSize: 13,
    fontWeight: 600,
    width: 80,
    textAlign: 'right',
    background: tokens.surface2,
    border: '1px solid ' + tokens.line2,
    borderRadius: 999,
    padding: '4px 10px',
    outline: 'none',
    color: tokens.ink,
    boxSizing: 'border-box'
  },
  unit: {
    fontSize: 12,
    color: tokens.ink3
  },
  requiredBang: {
    position: 'absolute',
    left: 8,
    color: tokens.danger,
    fontWeight: 700,
    fontSize: 13,
    lineHeight: 1,
    pointerEvents: 'none'
  },
  requiredChip: {
    background: tokens.dangerSoft,
    color: tokens.danger,
    fontSize: 10,
    padding: '1px 6px',
    borderRadius: 999,
    fontWeight: 600,
    lineHeight: '16px',
    whiteSpace: 'nowrap'
  }
}

const PillNumber = ({ value, onChange, unit, required, label }) => {
  const [focused, setFocused] = React.useState(false)

  const isEmpty = value === '' || value === null || value === undefined
  const showError = required && isEmpty

  const inputStyle = {
    ...styles.input,
    ...(focused
      ? {
          background: tokens.surface,
          borderColor: tokens.primary,
          boxShadow: '0 0 0 3px rgba(31,94,58,.18)'
        }
      : {}),
    ...(showError
      ? {
          borderColor: tokens.danger,
          paddingLeft: 22
        }
      : {})
  }

  return (
    <div style={styles.container}>
      {label && <span style={styles.label}>{label}</span>}
      <span style={styles.inputWrapper}>
        {showError && <span style={styles.requiredBang}>!</span>}
        <input
          type="number"
          style={inputStyle}
          value={value ?? ''}
          onChange={(e) => onChange && onChange(e.target.value)}
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
        />
      </span>
      {unit && <span style={styles.unit}>{unit}</span>}
      {showError && <span style={styles.requiredChip}>Required</span>}
    </div>
  )
}

export default PillNumber
